import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import GenericDialog from './GenericDialog';

const SearchEngineResultDialog = ({ open, handleClose }) => {
	const renderContent = () => {
		return (
			<div>
				<Typography variant="body1">
					See how your page will appear at search engine results page.
				</Typography>
			</div>
		);
	};
	return (
		<GenericDialog
			open={open}
			handleClose={handleClose}
			title="Search Engine Result"
			content={renderContent()}
		/>
	);
};

SearchEngineResultDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
};

export default SearchEngineResultDialog;
